import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CoverSetup } from '../../../../../../photographer-panel/src/graphql';
import { tap } from 'rxjs/operators';
import { ReplaySubject } from 'rxjs';
import { GetImageUrlService } from 'ZalamoLibrary/src/lib/core/image/image-loader/get-image-url.service';
import { SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'lib-cover-drawer',
    templateUrl: './cover-drawer.component.html',
    styleUrls: ['./cover-drawer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CoverDrawerComponent implements OnInit {
  coverDetails$ = new ReplaySubject<
    CoverSetup & {
      url: SafeResourceUrl;
      point: { x: number; y: number };
    }
  >(1);
  @Input() isBooking = false;
  @Input() set details(details: CoverSetup) {
    if (!details || !details.file) {
      return;
    }

    this.imageLoader
      .publicImage(details.file, 6000, 6000)
      .pipe(
        tap((url) => {
          this.coverDetails$.next({
            url,
            point: { x: details.x, y: details.y },
            ...details,
          });
        }),
      )
      .subscribe();
  }

  constructor(private imageLoader: GetImageUrlService) {}

  ngOnInit(): void {}
}
